export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const IDENTIFY_USER_EXIST_ON_DEVICE_START =
    'IDENTIFY_USER_EXIST_ON_DEVICE_START';
export const IDENTIFY_USER_EXIST_ON_DEVICE_SUCCESSFUL =
    'IDENTIFY_USER_EXIST_ON_DEVICE_SUCCESSFUL';
export const IDENTIFY_USER_EXIST_ON_DEVICE_FAIL =
    'IDENTIFY_USER_EXIST_ON_DEVICE_FAIL';

export const RESET_STATE = 'RESET_STATE';

export const COLLEGE_ID =' COLLEGE_ID';

export const DEPARTMENT_ID = 'DEPARTMENT_ID';

export const  COLLEGES = 'COLLEGES';

export const DEPARTMENTS = 'DEPARTMENTS';
